import { Component, inject, Injector, Input, OnDestroy } from '@angular/core';
import { DateRangeCalendarEventsListStore } from '@modules/calendar-app/services/date-range-events-list.store';
import { CalendarAppStateService } from '@modules/calendar-app/services/state.service';
import { CalendarEvent } from '@modules/calendar-app/types/calendar-event';
import { CalendarType } from '@modules/calendar-app/types/calendar-type';
import { ModalService } from '@modules/modal/services/modal.service';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-calendar-cell-context-menu',
  templateUrl: './calendar-cell-context-menu.component.html',
  styleUrls: ['./calendar-cell-context-menu.component.less'],
  standalone: false,
})
export class CalendarCellContextMenuComponent implements OnDestroy {
  private alive: Subject<void> = new Subject<void>();

  @Input() date: Date;
  @Input() calendarType: CalendarType;

  public readonly CalendarType = CalendarType;

  private readonly calendarAppStateService = inject(CalendarAppStateService);
  protected readonly dateRangeCalendarEventsListStore = inject(DateRangeCalendarEventsListStore);
  private readonly modalService = inject(ModalService);
  private readonly injector = inject(Injector);

  public ngOnDestroy() {
    this.alive.next();
    this.alive.complete();
  }

  protected createEvent(): void {
    this.calendarAppStateService
      .getBestSelectedCalendarUid()
      .pipe(take(1), takeUntil(this.alive))
      .subscribe((calendarUid) => {
        const calendarEvent = CalendarEvent.fromCalendarCell(null, this.date, this.calendarType);
        calendarEvent.calendarId = calendarUid;
        this.modalService.openFullForm(calendarEvent, this.injector);
      });
  }

  openCalendar(calendarType: CalendarType) {
    this.calendarAppStateService.calendarType.set(calendarType);
    this.dateRangeCalendarEventsListStore.setSelectedDate(this.date);
  }
}
